export enum SessionStatus {
  CLIENT_FILES_UPLOAD_REQUIRED = 'client_files_upload_required',
  CLIENT_FILES_PENDING_REVIEW = 'client_files_pending_review',
  CLIENT_FILES_UPDATE_REQUIRED = 'client_files_update_required',
  PARTNER_READY_TO_GO = 'partner_ready_to_go',
  PARTNER_UPLOAD_REQUIRED = 'partner_upload_required',
  PARTNER_DELIVERABLES_READY = 'partner_deliverables_ready',
  CANCELLED = 'cancelled'
}
